var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3399_20134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.90169 1.11332H5.56836V2.27999L4.62169 3.22666L5.03836 3.64332L6.23503 2.44999L6.23169 2.44666H6.23503V0.446655H2.23503V0.836655L2.90169 1.50332V1.11332Z",
    fill: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.935027 0.479989L0.465027 0.949989L3.43169 3.91666L2.23503 5.11332L2.23836 5.11666H2.23503V7.11332H6.23503V6.72332L7.06503 7.55332L7.53503 7.08332L0.935027 0.479989ZM5.56836 6.44666H2.90169V5.27999L3.84836 4.33332L5.56836 6.05666V6.44666Z",
    fill: "#A0A0A0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3399_20134"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosed);
export default __webpack_public_path__ + "static/media/closed.27e259f3eb81ba8e13362ddb9593ef59.svg";
export { ForwardRef as ReactComponent };